var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._l((_vm.$store.state.currentPage),function(component,i){return _c(component.componentName,{key:((component.componentName) + "-" + i),tag:"component",class:[
      'app-component',
      component.data !== undefined && component.data.bgColored ? 'app-component--colored' : false ],attrs:{"data":component.data}})}),_c('AppFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }